// import "./styles/globals.css";
// import { initRouter } from "./router.js";
// import { initSmartsupp } from "./services/smartsupp.js";

// const root = document.getElementById("app");
// initRouter(root);
// initSmartsupp();

// apps/public/src/main.js
import "./styles/globals.css";
import { initRouter } from "./router.js";
import { initTawkto } from "./services/tawkto.js";

const root = document.getElementById("app");
initRouter(root);
initTawkto();